import React from "react";
import {toDangerouslySetHtml} from "../../Utilities/htmlUtilities";

interface HtmlDisplayProps {
    className?: string;
    disabled?: boolean;
    html?: string;
    isUpdatedLive?: boolean;
    isInline?: boolean;
    name?: string;
    onClick?: () => void;
}

export const HtmlDisplay = ({className = "", disabled, name, html = "", isInline, isUpdatedLive, onClick}: HtmlDisplayProps) => {
    const classes = `${className} ${
        onClick ? "htmlDisplay--editable is-clickable" : ""
    }`;

    const ariaLive: "polite" | "off" = isUpdatedLive ? "polite" : "off";

    const props = {
        "aria-disabled": disabled,
        "aria-live": ariaLive,
        className: `htmlDisplay is-dangerouslySetHtml ${classes}`,
        id: name,
        "data-testid": name,
        onClick: disabled ? undefined : onClick,
        tabIndex: onClick ? 0 : undefined,
        dangerouslySetInnerHTML: toDangerouslySetHtml(html),
    };

    return isInline ? <span {...props} /> : <div {...props} aria-disabled={disabled}/>;
};
